import React, { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import Skeleton from '@mui/material/Skeleton';
import './styles.css';

const VisualizadorImagenesDetalle = ({ articulo, instalacion }) => {
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(true);
    const images = [];

    const renderItem = (item) => {
        return (
            <div className="image-gallery-image-wrapper">
                {loading && (
                    <Skeleton 
                        variant="rectangular" 
                        width="100%" 
                        height={500} 
                        animation="wave" 
                        style={{ borderRadius: '8px' }}
                    />
                )}
                <img 
                    src={item.original} 
                    alt="" 
                    onLoad={() => setLoading(false)}
                    onError={() => {
                        setHasError(true);
                        setLoading(false);
                    }}
                    style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'contain',
                        display: loading ? 'none' : 'block',
                    }} 
                />
            </div>
        );
    };

    // Priorizar lista de imágenes si existe
    if (articulo.listaImagenesArticulos && articulo.listaImagenesArticulos.length > 0) {
        articulo.listaImagenesArticulos.forEach(img => {
            const fixedPath = img.path.replace(/\\/g, '/');
            images.push({
                original: fixedPath,
                thumbnail: fixedPath,
                renderItem: renderItem
            });
        });
    } else {
        // Fallback a imágenes individuales
        const mainImage = articulo.pathImagen || articulo.imagenSuperior || articulo.imagenLogin;
        if (mainImage) {
            const fixedPath = mainImage.replace(/\\/g, '/');
            images.push({
                original: fixedPath,
                thumbnail: fixedPath,
                renderItem: renderItem
            });
        }
    }

    if (images.length === 0 || hasError) {
        return (
            <div className='imageDefault' style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f0f0f0', borderRadius: '8px' }}>
                <div style={{ textAlign: 'center' }}>
                    {instalacion && instalacion.logoCard ? (
                        <img alt="Producto sin foto" src={instalacion.logoCard} style={{ maxHeight: '100px' }} />
                    ) : (
                        <div style={{ fontSize: '48px', color: '#ccc' }}>📷</div>
                    )}
                    <div style={{ marginTop: '10px', color: '#666', fontWeight: 'bold' }}>Producto sin foto</div>
                </div>
            </div>
        );
    }

    return (
        <div className="visualizadorImagenesDetalle">
            <ImageGallery
                showBullets={images.length > 1}
                showFullscreenButton={false}
                showPlayButton={false}
                showThumbnails={images.length > 1}
                showIndex={false}
                items={images}
                lazyLoad={true}
            />
        </div>
    );
};

export default VisualizadorImagenesDetalle;
